import { render } from "./CreateNotificationForm.vue?vue&type=template&id=cc1370ee&scoped=true"
import script from "./CreateNotificationForm.vue?vue&type=script&lang=js"
export * from "./CreateNotificationForm.vue?vue&type=script&lang=js"

import "./CreateNotificationForm.vue?vue&type=style&index=0&id=cc1370ee&lang=scss&scoped=true"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc1370ee"]])

export default __exports__